export const web_title = "منصة طفلي";
export const web_desc = "منصة تثقيفية غير ربحية تُعنى بكل ما يخص الطفل من الولادة إلى عمر السنتين";
export const web_url = "https://www.xn--2gbujy.com/";
